import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	desktopMenu: {
		alignItems: "center",
		display: "flex",
		gap: theme.spacing(5),
		height: "100%",
		justifyContent: "flex-end",
		maxHeight: 96,
		"& .mco-view-component-header-desktop-menu__level1:last-child:after": {
			display: "none"
		}
	},
	link: {
		fontWeight: 700,
		padding: theme.spacing(1, 0),
		transition: "250ms color ease-out, 250ms opacity ease-out",
		"&:hover": {
			color: theme.palette.secondary.main
		}
	},
	linkCurrent: {
		color: theme.palette.primary.main + " !important"
	},
	linkOther: {
		opacity: 0.5
	},
	linkSelected: {
		color: theme.palette.primary.main
	},
	level1: {
		alignItems: "center",
		display: "flex",
		height: "100%",
		position: "relative",
		"&:after": {
			background: theme.palette.primary.main,
			borderRadius: 1,
			content: "''",
			display: "block",
			height: 4,
			opacity: 0.5,
			position: "absolute",
			right: -22,
			width: 4
		}
	},
	subList: {
		background: "#6685B7",
		display: "grid",
		gap: theme.spacing(2),
		minWidth: 200,
		padding: theme.spacing(4, 5),
		position: "absolute",
		top: "100%"
	},
	link2: {
		color: theme.palette.common.white,
		display: "block",
		fontWeight: 600,
		transition: "250ms color ease-out",
		whiteSpace: "nowrap",
		"&:hover": {
			color: "#ffe800"
		}
	},
	link2Selected: {}
}));

export default styles;
